<template>
  <div class="question-view-dialog text-drag" >
    <div class="quest">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
      </div>

      <div class="choice-list">
        <div class="choice-single" v-for="(its, idx) in choice" :key="idx" :id="'single' + idx" draggable="true" @dragstart="dragStart($event, idx)">
          <span><vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="its.content" :safe="false"/></span>
        </div>
      </div>

      <div class="question-list">
        <div class="single" :data-id="its.id" v-for="(its, idx) in question" :key="idx">
          <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="its.arr" :safe="false"/>
        </div>
      </div>

      <div class="question-list" v-if="false">
        <div class="single" :data-id="its.id" v-for="(its, idx) in question" :key="idx">
          <!-- <span class="single-letter" v-if="question.length != 1">{{ letter[idx] }}.</span> -->
          <div class="single-cte" v-for="(item, index) in its.arr" :key="index">
            <div class="some-as"  v-if="item.answerArea && item.type == 'decimals'" >
              <div class="some-child" v-if="item.map[0].fill">
                <span>{{ item.map[0].prevVal }}</span>
                <input type="text" class="fill numerator"> 
                <span>{{ item.map[0].nextVal }}</span>
              </div>
              <div class="numerator" v-else>{{ item.map[0].val }}</div>
              
              <div class="some-child" v-if="item.map[1].fill">
                <span>{{ item.map[1].prevVal }}</span>
                <input type="text" class="fill numerator">
                <span>{{ item.map[1].nextVal }}</span>
              </div>
              <div class="denominator" v-else>{{ item.map[1].val }}</div>
            </div>
            <div v-else-if="item.answerArea && item.type == 'default'" 
              class="input determine-success-br" data-value="" draggable="true" 
              @drop="drop($event)" @dragover="dragover" @click="clickFillEare($event)">
              <span>
                <vue-mathjax :formula="item.text" :safe="false"/>
              </span>
              <div class="success"></div>
              <div class="error"></div>
              <div class="mask"></div>
            </div>
            <span v-else>
              <vue-mathjax draggable="true" :formula="item.text" :safe="false"/>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'

export default {
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      mathjaxNum: 0,
      letter,
      topic: '',
      answerList: [],
      
      choice: [],
      question: [],
      answerNum: 0,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      n: 0
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    findImageLinks(text) {
      // 匹配常见的图片链接格式，如 .jpg, .jpeg, .png, .gif 等
      const regex = /(https?:\/\/.*?\.(?:png|jpg|jpeg|gif))/gi;
      let match;
      const imageLinks = [];

      // 使用正则表达式在文本中查找匹配的图片链接
      while ((match = regex.exec(text)) !== null) {
          imageLinks.push(match[0]);
      }

      return imageLinks;
    },
    onRenderComplete(i) {
      let num = 1 + this.choice.length + this.question.length
      
      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      this.$emit('permissions', false)
      // 样式清空
      let blocks = document.querySelectorAll('.question-list .single .input')
      for(let i = 0; i < blocks.length; i++) {
        blocks[i].querySelector('span').innerHTML = ''
      }
    },
    showTrueFalse() {
      let { form, recordQuestion } = this, answers = {},
      blocks = document.querySelectorAll('.question-list .single')
      form.answers.filter((its, idx) => {
        if(idx != form.answers.length - 1) {
          answers[its.choice_id] = JSON.parse(its.value)
        }
      })

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        id = block.dataset.id,
        childs = block.querySelectorAll('.input')
        
        for(let j = 0; j < childs.length; j++) {
          let {value, html} = recordQuestion[id][j]
          // 回显答案
          childs[j].querySelector('span').innerHTML = html

          // 回显对错
          if(answers[id][j] == value) {
            childs[j].classList.add('determine-success-br')
          } else {
            childs[j].classList.add('determine-error-br')
          }
        }
      }

      console.log(form)
    },
    changeChoice(content) {
      content = content.replaceAll('\\left(', pLeft).replaceAll('\\right)', pRight)
      // let regex = /\(\)/g, 
      let regex = /\$\$([^$]*)\$\$|\$([^$]*)\$/g,
      regex1 = /@(.*?)#/g,
      // regex1 = /(?<!\\left)(?<!\\right)\(([^()]*)\)/g,
      regexMap = {
        over: /\$(([^$]*)\\over([^$]*))\$/,
        frac: /\$(([^$]*)\\frac([^$]*))\$/
      }, res, grade, arr = []
      // , subscript = 0

      res = content.match(regex1)
      grade = content.match(regex)
      if(grade) {
        for(let i = 0; i < grade.length; i++) {
          let its = grade[i],
          over = its.match(regexMap.over),
          frac = its.match(regexMap.frac)
          // 分数结构
          console.log(over)
          if(over) {
            // 处理數据 判断是否被()括住
            for(let i = 2; i < over.length; i++) {
              let val = over[i].match(regex1)
              // 在替换之前将 \left(, \right) 转为()
              over[i] = over[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
           
              if(val) {
                let constVal = over[i].split('()')
                over[i] = {fill: true, val: constVal}
              }
              else over[i] = {fill: false, val: over[i]}
            }

            // 判断fill 是否为true
            let isFill = over.some(its => its.fill)
            if(!isFill) {
              continue ;
            }

            let [, , child, parent] = over

            arr.push(...[
              { text: '', answerArea: true, type: 'decimals', map: [
                  child, parent
                ]
              }, 
            ])
            
            let echoHtml = `
            <div class="some-as">
              ${ child.fill ? 
                  `
                  <div class="some-child">
                    ${
                      child.val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="determine-success-br input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="numerator">${child.val}</div>` }
              ${ parent.fill ? 
                  `
                  <div class="some-child">
                    ${
                      parent.val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="determine-success-br input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="denominator">${parent.val}</div>` }
            </div>
            `
            content = content.replace(its, echoHtml)
          }
          // 带分数结构
          console.log(frac)
          if(frac) {
            // integer 整数部分，fraction 分数部分
            let [, , integer, fraction] = frac
            , fractionRegex = /\{.*?\}/g
            // 取出同时去除首尾的大括号
            , [child, parent] = fraction.match(fractionRegex)
                              .map(s => s.slice(1, -1))
            
            let echoData = [integer, child, parent]
            // 处理數据 判断是否被()括住
            for(let i = 0; i < echoData.length; i++) {
              let val = echoData[i].match(regex1)
              // 在替换之前将 \left(, \right) 转为()
              echoData[i] = echoData[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
              
              if(val) {
                let constVal = echoData[i].split('()')
                echoData[i] = {fill: true, val: constVal}
              } else echoData[i] = {fill: false, val: echoData[i]}
            }

            // 判断fill 是否为true
            let isFill = echoData.some(its => its.fill)
            if(!isFill) {
              continue ;
            }

            let echoHtml = `
            <div class="mixed-number">
              ${ echoData[0].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[0].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="determine-success-br input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  `:
                  `<div class="mixed">${echoData[0].val}</div>` }
              <div class="some-as">
                ${ echoData[1].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[1].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="determine-success-br input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  `:
                  `<div class="numerator">${echoData[1].val}</div>` }
  
                ${ echoData[2].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[2].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="determine-success-br input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="denominator">${echoData[2].val}</div>` }
              </div>
            </div>
            `
            content = content.replace(its, echoHtml)
          }
        }
      }

      if(res) {
        for(let i = 0; i < res.length; i++) {
          // console.log(res[i])
          // let s = content.substring(0, content.indexOf(res[i])),
          
          // arr.push(...[
          //   { text: s, answerArea: false, type: 'default' }, 
          //   { text: answer, answerArea: true, type: 'default' }, 
          // ])
          // subscript = (s + res[i]).length
          // content = content.substring(subscript)
          let echoHtml = `
          <div class="input determine-success-br">
          </div>`
          content = content.replace(res[i], echoHtml)
        }
      }
      console.log(content)
      // arr.push({ text: content, answerArea: false, type: 'default' })
      // content = content.replaceAll('\\left(', '(').replaceAll('\\right)', ')')
      content = content.replaceAll(pLeft, '(').replaceAll(pRight, ')')
      return `<div class="single-flex">${content}</div>`
    },
    dragStart(e, idx) {
      e.dataTransfer.setData('textDragMsg', idx)
    },

    dragover(e) {
      e.preventDefault()
    },

    drop(e) {
      let textDragMsg = e.dataTransfer.getData('textDragMsg')
      
      // 存在 e.target 为子节点  不是「填空区域」获取父节点后再作处理
      let eareBox = e.target.classList.contains('input') ? e.target : e.target.parentNode
      // 获取拖拽的节点
      let dragNode = document.querySelector('#single' + textDragMsg)
      eareBox.innerHTML = dragNode.innerHTML
      eareBox.dataset.value = this.choice[textDragMsg].content

      // 保存答案
      let singles = document.querySelectorAll('.single'),
      answerMap = {}
      console.log(singles)
      let recordQuestion = {}
      for(let i = 0; i < singles.length; i++) {
        let single = singles[i],
        id = single.dataset.id,
        values = single.querySelectorAll('.input')

        for(let j = 0; j < values.length; j++) {
          let val = values[j],
          value = val.dataset.value
          if(answerMap[id]) {
            answerMap[id].push(value)
            recordQuestion[Number(id)].push({
              value, 
              html: val.innerHTML
            })
          } else {
            answerMap[id] = [value]
            recordQuestion[Number(id)] = [{
              value, 
              html: val.innerHTML
            }]
          }
        }
      }

      this.answer_results.student_choices = []
      this.recordQuestion = recordQuestion
      for(let key in answerMap) {
        this.answer_results.student_choices.push({choice_id: Number(key), value: JSON.stringify(answerMap[key])})
      }
      this.form.choices.filter(its => {
        if(!its.value) {
          this.answer_results.student_choices.push({choice_id: Number(its.id), value: JSON.stringify([])})
        }
      })
      console.log(this.answer_results.student_choices)
      // 是否满足下一题的条件
      let inputs = document.querySelectorAll('.input > span'),
      num = 0
      for(let i = 0; i < inputs.length; i++) {
        if(inputs[i].innerText != '') {
          num ++
        }
      }
      if(1 <= num) this.$emit('permissions', true)
      else this.$emit('permissions', false)
    },

    // 填空区域点击事件
    clickFillEare(e) {
      // 存在 e.target 为子节点  不是「填空区域」获取父节点后再作处理
      let eareBox = e.target.classList.contains('input') ? e.target : e.target.parentNode
      eareBox.innerText = ''
      eareBox.dataset.value = ''
      this.$emit('permissions', false)
    },
    initData() {
       
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      this.choice = []
      this.question = []
      this.answerNum = 0

      let content = JSON.parse(this.form.content)
      console.log(this.form)
      console.log(content)
      let deWeight = []
      this.choice = JSON.parse(JSON.stringify(content.choice)).filter(its => {
        /// 匹配出图片链接，并赋予标签
        let imgs = this.findImageLinks(its.content)
        for(let i = 0; i < imgs.length; i++) {
          let imgDomStr = `<img src="${imgs[i]}" />`
          its.content = its.content.replace(imgs[i], imgDomStr)
        }

        if(!deWeight.includes(its.content)) {
          deWeight.push(its.content)
        } else {
          return false
        }
        
        return its.content && its
      })

      for(let i = 0; i < this.choice.length; i++) {
        let randomNum = Math.floor(Math.random() * this.choice.length);
        [this.choice[i], this.choice[randomNum]] = [this.choice[randomNum], this.choice[i]]
      }

      this.question = JSON.parse(JSON.stringify(this.form.choices)).filter(its => {
        /// 匹配出图片链接，并赋予标签
        let imgs = this.findImageLinks(its.value)
        console.log(its.value)
        console.log(imgs)
        for(let i = 0; i < imgs.length; i++) {
          let imgDomStr = `<img src="${imgs[i]}" class="text-img" />`
          its.value = its.value.replace(imgs[i], imgDomStr)
        }
        
        return its.value && its
      })
      .map(its => {
        // 还原答案
        return {id: its.id, arr: this.changeChoice(its.value)}
      })
      // this.question.filter(its => {
      //   its.arr.filter(item => item.answerArea && this.answerNum++)
      // })
      // this.
      console.log(this.question)
      this.$nextTick(() => {
        let doms = document.querySelectorAll('.question-view-dialog .input') 

        for(let i = 0; i < doms.length; i++) {
          let answer = content.choice.splice(0, 1)[0].content
          let [img] = this.findImageLinks(answer)
          if(img) {
            doms[i].innerHTML = `<img src="${img}" />`
          } else {
            doms[i].innerHTML = answer
          }
          doms[i].onclick = (e) => {
            console.log('cilick')
            this.clickFillEare(e)
          }
          doms[i].ondrop = (e) => this.drop(e)
          doms[i].ondragover = this.dragover
        }

      })
      // if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  created() {
    this.initData()
  }
}
</script>

<style scoped lang="scss">
.question-view-dialog.text-drag {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;

  .quest {
    width: 100%;
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }
    .choice-list {
      margin-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;

      .choice-single {
        min-width: 100px;
        height: 60px;
        margin: 0 10px 10px 0;
        padding: 0 5px;
        background-color: #f8ae64;
        border-radius: 8px;
        box-shadow: 1px 2px 2px 1px #ccc;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;

        &:hover {
          opacity: .8;
        }
      }
    }
    .question-list {
      margin-top: 20px;
      width: 100%;
      padding: 0;
      overflow-x: auto;

      .single {
        width: 100%;
        // height: 32px;
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 10px;
        // border: 2px solid #fcd2ab;
        // background-color: #fcd2ab;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;

        .single-letter {
          font-size: 15px;
          // font-weight: 700;
          margin-right: 5px;
        }

        .single-cte {
          font-size: 14px;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;

          

          .input-success {
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: 1px solid #007416;
              border-radius: 10px;
            }
          }
          .input-error {
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: 1px solid #d60215;
              border-radius: 10px;
            }
          }
        }

        &:hover {
          opacity: .8;
        }
      }

      .single-select {
        border-color: #d37525;
        background-color: #f8ae64;
      }
    }

  }
}
</style>

<style lang="scss">
.question-view-dialog.text-drag {
  .single-flex {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .text-img, img {
      width: auto;
      height: 50px;
      margin: 0 5px;
    }
  }

  .choice-single {
    position: relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      height: 100%;
      width: auto;
    }
  }

  .text-img{
    width: auto;
    height: 50px;
    margin: 0 5px;
  }

  .input {
    min-width: 100px;
    height: 40px;
    background-color: #fcd2ab;
    border-radius: 10px;
    padding: 0 5px;
    box-sizing: border-box;
    outline: none;
    border: none;
    margin: 0 10px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
    position: relative;
    margin-bottom: 10px;

    & > img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      height: 100%;
      width: auto;
    }
  }

  .some-as {
    display: inline-block;
    margin: 0 5px;
    position: relative;
    color: #333;
    vertical-align: middle;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 1px;
      width: 100%;
      background-color: #333;
    }

    .some-child {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      margin: 8px 0;

      & > span {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .numerator, .denominator {
      margin: 5px 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
    }

    .numerator.fill, .denominator.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      width: 60px;
      text-align: center;
      padding: 5px;
      box-sizing: border-box;
    }
  }

  .mixed-number {
    display: inline-flex;
    align-items: center;
    .mixed {
      color: #333;
    }

    .mixed.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      width: 60px;
      height: 40px;
      text-align: center;
      padding: 5px;
      color: #333;
    }
  } 
}
</style>